<template>
  <div class="basicconfig" style="height: 100%">
    <div class="return">
      <el-button @click="submit" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
    </div>
    <div class="content">
      <div>
        <h4 class="title">{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="checkbox">
          <div
            class="checkboxItem"
            v-for="(item, index) in checkList"
            :key="index"
          >
            <el-checkbox v-model="item.model">
              <el-popover
                placement="bottom"
                :title="item.label"
                width="200"
                trigger="hover"
                :content="item.desc">
                <span slot="reference" class="collapseHeaderItem">{{item.label}}</span>
              </el-popover>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div>
        <h4 class="title">{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
        <div class="checkbox">
          <div style="margin-bottom: 20px;">
            <el-checkbox v-model="isOnlyStoreAddMember" style="vertical-align: bottom;">
              {{$t('LanguageLib.QYWX_CONFIG')}}
            </el-checkbox>
          </div>
        </div>
      </div>
      <div>
        <h4 class="title">{{$t('LanguageLib.DEFAULT_PASSWORD_CONFIGURATION')}}</h4>
        <div style="padding-left: 16px;">
            <div style="margin-bottom: 25px;">
              <el-radio-group v-model="passWordType">
                <el-radio style="margin-bottom:6px;" label="Random">{{$t('LanguageLib.RANDOM_PASSWORD1')}}</el-radio>
              </el-radio-group>
              <div style="padding-left:24px;">
                <el-select :disabled="passWordType !== 'Random'" style="margin-right:10px;width:160px;height:40px;" v-model="passWordComplexity">
                  <el-option
                    v-for="(item, index) in passwordStrength"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select :disabled="passWordType !== 'Random'" style="width:62px;height:40px;" v-model="passwordNum">
                  <el-option
                    v-for="(item, index) in [4, 6, 8, 10]"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <span style="font-size: 14px;font-weight: 400;color: #666666;margin-left:6px;">
                  {{$t('LanguageLib.RANDOM_PASSWORD')}}
                </span>
              </div>
            </div>
            <div style="margin-bottom: 25px;">
              <el-radio-group v-model="passWordType">
                <el-radio style="margin-bottom:6px;" label="UserAccountLastNum">{{$t('LanguageLib.PHONE_NUMBER')}}</el-radio>
              </el-radio-group>
              <div style="padding-left:24px;">
                <span style="font-size: 14px;font-weight: 400;color: #666666;margin-right:6px;">
                   {{$t('LanguageLib.AFTER_THE_PHONE_NUMBER')}}
                </span>
                <el-select :disabled="passWordType !== 'UserAccountLastNum'" style="width:62px;height:40px;" v-model="passwordNum">
                  <el-option
                    v-for="(item, index) in [4, 6, 8]"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <span style="font-size: 14px;font-weight: 400;color: #666666;margin-left:6px;">
                  {{$t('LanguageLib.BIT')}}
                </span>
              </div>
            </div>
            <div style="margin-bottom: 25px;">
              <el-radio-group v-model="passWordType">
                <el-radio style="margin-bottom:6px;" label="FixedPassWord">{{$t('LanguageLib.FIXED_PASSWORD')}}</el-radio>
              </el-radio-group>
              <div style="padding-left:24px;">
                <el-input :disabled="passWordType !== 'FixedPassWord'" style="width:230px;height:40px;" v-model="defultPassWord" :placeholder="$t('LanguageLib.PleaseEnter')"></el-input>
              </div>
            </div>
        </div>
      </div>
      <div style="margin-bottom: 25px;">
        <h4 class="title">
          {{$t('LanguageLib.MODULE_COLOR')}}
          <el-tooltip style="cursor: pointer;" effect="light" :content="$t('LanguageLib.ONLY_RPLUS_QYWX')" placement="bottom">
            <span class="remarks">?</span>
          </el-tooltip>
        </h4>
        <div class="checkbox">
            <div class="ModuleBox">
              <el-collapse v-show="colorMatchingType === 0" v-model="activeNames" style="border:0;">
                <div v-for="(item, index) in colourTypeModuleList" :key="index" style="padding-left:10px;">
                  <span style="float:left;line-height: 48px;margin-top: 16px;margin-right:10px;" class="colorbox" :style="'background:'+ item.colourValue +';'"></span>
                  <span style="font-size: 14px;color: #606266;float:left;line-height: 48px;max-width: 240px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap; cursor: pointer;" :title="item.typeName">{{ item.typeName }}</span>
                  <el-collapse-item :name="index">
                    <div style="font-size: 14px;color: #606266;height:48px;line-height: 48px;margin-left:16px;max-width: 240px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;cursor: pointer;" v-for="(Myitem, Myindex) in item.moduleList" :key="Myindex" :title="Myitem.moduleName">
                      {{ Myitem.moduleName }}
                    </div>
                  </el-collapse-item>
                  <el-divider style="margin: 0;"></el-divider>
                </div>
              </el-collapse>
              <div v-show="colorMatchingType === 1">
                <ul>
                  <li @click="checkmoudel(item)" class="listItem" v-for="(item, index) in moduleColourList" :key="index" :style=" item.active ? 'padding-left: 10px;background:#f6f6f6;cursor: pointer;' : 'padding-left: 10px;cursor: pointer;'">
                    <span style="vertical-align: middle;line-height: 48px;margin-right:10px;" class="colorbox" :style="'background:'+ item.colourValue +';'"></span>
                    <span style="font-size: 14px;color: #606266;line-height: 48px;max-width: 240px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap; cursor: pointer;" :title="item.moduleName">{{ item.moduleName }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="ColorPickBox">
              <div class="radioPick">
                <el-radio v-model="colorMatchingType" :label="0">{{$t('LanguageLib.SYSTEM_DISTRIBUTION')}}</el-radio>
                <el-radio v-model="colorMatchingType" :label="1">{{$t('LanguageLib.CUSTOM_COLOR_MATCHING')}}</el-radio>
              </div>
              <div class="colorPick" style="padding-top:26px;box-sizing: border-box;">
                <div  v-for="(item, index) in schemeModuleList" :key="index">
                  <div class="ColorMatching" v-show="colorMatchingType === 0" style="display:flex;flex-wrap: wrap;">
                    <div style="height: 110px;line-height: 110px;max-width: 152px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;cursor: pointer;">
                      <el-radio @change="schemechange" v-model="scheme" :label="index+1" :title="item.schemeDesction">{{item.schemeDesction}}</el-radio>
                    </div>
                    <div style="display: flex;flex-wrap: wrap;">
                      <div style="width:110px;margin: 0 15px 26px 15px;" v-for="(myitem, myindex) in item.colourTypeList" :key="myindex">
                        <div class="colordiv" :style="'width:110px;height:110px;background:'+ myitem.colourValue +';'"></div>
                        <div class="typename" style="font-size: 14px;color: #606266;width:110px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;text-align:center;margin-top:5px;">
                          {{myitem.typeName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="display: flex;" class="CustomColorMatching" v-show="colorMatchingType === 1">
                  <el-color-picker color-format="rgb" @change="ChangeColor" style="left: 0;margin-right: 10px;" v-model="checkedColor"></el-color-picker>
                  <el-button style="margin-top: 5px;" @click="RestoreDefault" type="primary">{{$t('LanguageLib.RESTORE_DEFAULT_COLOR')}}</el-button>
                  <el-button style="margin-top: 5px;" @click="clopyColor" type="primary">{{$t('LanguageLib.CLOPY_COLOR')}}</el-button>
                  <el-button style="margin-top: 5px;" @click="delRolesData" :disabled="clopycolorB">{{$t('LanguageLib.ADHESIVE_COLOR')}}</el-button>
                  <!-- <div style="position:relative">
                    <el-color-picker color-format="rgb" @change="ChangeColor" style="left: 0;" v-model="checkedColor"></el-color-picker>
                  </div> -->
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyallocationApi from '../../api/companyallocation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'companyallocation',
  props: ['currentPage', 'pageSize', 'searchText', 'sort', 'sortOrder'],
  data () {
    return {
      checkList: [{
        label: this.$t('LanguageLib.OPEN_SHOP'),
        model: false,
        desc: this.$t('LanguageLib.OPEN_STORE_DESC'),
        type: 0
      }, {
        label: this.$t('LanguageLib.OPEN_ADDRESS_BOOK'),
        model: false,
        desc: this.$t('LanguageLib.OPEN_ADDRESS_BOOK_DESC'),
        type: 1
      }, {
        label: this.$t('LanguageLib.ALLOW_EXPORT_OF_CONTACTS'),
        model: false,
        desc: this.$t('LanguageLib.ALLOW_EXPORT_OF_CONTACTS_DESC'),
        type: 2
      }, {
        label: this.$t('LanguageLib.CHANGE_PASSWORD_AT_FIRST_LOGIN'),
        model: false,
        desc: this.$t('LanguageLib.CHANGE_PASSWORD_AT_FIRST_LOGIN_DESC'),
        type: 3
      }, {
        label: this.$t('LanguageLib.TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE'),
        model: false,
        desc: this.$t('LanguageLib.TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE_DESC'),
        type: 4
      }], // 基础配置数据
      isOnlyStoreAddMember: false,
      BasicConfigurationInfo: null,
      passwordNum: 4, // 随机密码位数
      passwordStrength: [{ label: this.$t('LanguageLib.ORDINARY_STRENGTH'), value: 0 }, { label: this.$t('LanguageLib.HIGH_STRENGTH'), value: 1 }], // 密码强度
      passWordComplexity: 0,
      defultPassWord: '', // 固定密码
      passWordType: '',
      colourTypeModuleList: '',
      colorMatchingType: '', // 配色类型
      moduleColourList: [], // 自定义模块列表
      schemeModuleList: '', // 系统配色方案
      scheme: '', // 系统配色方案选择
      checkedColor: '', // 模块颜色
      activeNames: [], // 折叠面板展开数组
      defaluteColorArr: [], // 模板列表默认颜色数组
      clopycolorA: '', // 复制颜色
      clopycolorB: true, // 复制颜色
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    companyallocationApi.GetBasicConfigurationInfo('get', '/ownerInfo/BasicConfigurationInfo', { ownerId: window.localStorage.getItem('ownerId') })
      .then(res => {
        NProgress.done()
        next(vm => {
          vm.BasicConfigurationInfo = res.data
          vm.passWordType = res.data.passWordType
          vm.passWordComplexity = res.data.passWordComplexity
          vm.defultPassWord = res.data.defultPassWord
          vm.colourTypeModuleList = res.data.colourTypeModuleList
          vm.colorMatchingType = res.data.colorMatchingType
          vm.schemeModuleList = res.data.schemeModuleList
          vm.moduleColourList = res.data.moduleColourList
          vm.passwordNum = res.data.passWordLenght
          vm.isOnlyStoreAddMember = res.data.isOnlyStoreAddMember
          // 自定义默认选中第一条数据
          if (vm.moduleColourList && vm.moduleColourList.length > 0) {
            vm.moduleColourList[0].active = true
            vm.checkedColor = res.data.moduleColourList[0].colourValue
          }
          vm.scheme = res.data.scheme === 0 ? 1 : res.data.scheme
          vm.defaluteColorArr = []
          vm.activeNames = []
          for (var k in vm.colourTypeModuleList) {
            vm.activeNames.push(k * 1)
            var color = vm.colourTypeModuleList[k].colourValue
            for (var x in vm.colourTypeModuleList[k].moduleList) {
              vm.defaluteColorArr.push({
                moduleId: vm.colourTypeModuleList[k].moduleList[x].moduleId,
                moduleName: vm.colourTypeModuleList[k].moduleList[x].moduleName,
                color: color
              })
            }
          }
          for (var i in vm.checkList) {
            switch (vm.checkList[i].type) {
              case 0:
                vm.checkList[i].model = vm.BasicConfigurationInfo.isOpenStoreInfo
                break
              case 1:
                vm.checkList[i].model = vm.BasicConfigurationInfo.isOpenAddressBook
                break
              case 2:
                vm.checkList[i].model = vm.BasicConfigurationInfo.isCanExportAddressBook
                break
              case 3:
                vm.checkList[i].model = vm.BasicConfigurationInfo.isFirstLoginResetPwd
                break
              case 4:
                vm.checkList[i].model = vm.BasicConfigurationInfo.isOpenWatermark
                break
            }
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
  },
  methods: {
    // 改变颜色
    ChangeColor () {
      for (var i in this.moduleColourList) {
        if (this.moduleColourList[i].active) {
          this.moduleColourList[i].colourValue = this.checkedColor
        }
      }
      this.$forceUpdate()
    },
    // 恢复默认颜色
    RestoreDefault () {
      for (var i in this.moduleColourList) {
        if (this.moduleColourList[i].active) {
          for (var k in this.defaluteColorArr) {
            if (this.moduleColourList[i].moduleId === this.defaluteColorArr[k].moduleId) {
              this.moduleColourList[i].colourValue = this.defaluteColorArr[k].color
              this.checkedColor = this.defaluteColorArr[k].color
            }
          }
        }
      }
      this.$forceUpdate()
    },
    // 复制颜色
    clopyColor () {
      this.clopyColorA = this.checkedColor
      this.clopycolorB = false
      this.$message({
        type: 'success',
        message: this.$t('LanguageLib.SUCCESS_COLOR')
      })
      this.$forceUpdate()
    },
    //  黏贴颜色
    delRolesData () {
      for (var i in this.moduleColourList) {
        if (this.moduleColourList[i].active) {
          this.moduleColourList[i].colourValue = this.clopyColorA
          this.checkedColor = this.clopyColorA
        }
      }
      this.$forceUpdate()
    },
    checkmoudel (item) {
      for (var i in this.moduleColourList) {
        this.moduleColourList[i].active = false
        if (this.moduleColourList[i].moduleId === item.moduleId) {
          this.moduleColourList[i].active = true
          this.checkedColor = this.moduleColourList[i].colourValue
        }
      }
      this.$forceUpdate()
    },
    // 方案选择
    schemechange (value) {
      for (var i in this.colourTypeModuleList) {
        var item = this.colourTypeModuleList[i]
        for (var k in this.schemeModuleList[value - 1].colourTypeList) {
          var item1 = this.schemeModuleList[value - 1].colourTypeList[k]
          if (item.colourTypeId === item1.colourTypeId) {
            item.colourValue = item1.colourValue
          }
        }
      }
    },
    // 保存数据
    submit () {
      this.loadingSave = true
      var isOpenAddressBook = false
      var isOpenStoreInfo = false
      var isCanExportAddressBook = false
      var isFirstLoginResetPwd = false
      var isOpenWatermark = false
      for (var i in this.checkList) {
        switch (this.checkList[i].type) {
          case 0:
            isOpenStoreInfo = this.checkList[i].model
            break
          case 1:
            isOpenAddressBook = this.checkList[i].model
            break
          case 2:
            isCanExportAddressBook = this.checkList[i].model
            break
          case 3:
            isFirstLoginResetPwd = this.checkList[i].model
            break
          case 4:
            isOpenWatermark = this.checkList[i].model
            break
        }
      }
      var data = {
        ownerId: this.$commonfun.localStorage.getitem('ownerId'),
        isOpenAddressBook: isOpenAddressBook,
        isOpenStoreInfo: isOpenStoreInfo,
        isCanExportAddressBook: isCanExportAddressBook,
        isFirstLoginResetPwd: isFirstLoginResetPwd,
        isOpenWatermark: isOpenWatermark,
        passWordType: this.passWordType,
        passWordLenght: this.passwordNum,
        passWordComplexity: this.passWordComplexity,
        colorMatchingType: this.colorMatchingType,
        scheme: this.scheme,
        defultPassWord: this.defultPassWord,
        moduleColourList: this.moduleColourList,
        isOnlyStoreAddMember: this.isOnlyStoreAddMember
      }
      companyallocationApi.SaveBasicConfiguration('post', '/ownerInfo/BasicConfigurationSetting', data)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.SAVED_SUCCESSFULLY')
          })
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.basicconfig{
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 25px;
    padding-top: 15px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 20px;
      .remarks{
        width: 12px;
        height: 12px;
        background: #C9C9C9;
        border-radius: 50%;
        display: inline-block;
        color: #fff;
        font-size: 12px;
        text-align: center;
        line-height: 12px;
      }
    }
    .ModuleBox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .ModuleBox::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .ModuleBox::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      border-radius: 5px;
      background: #fff;
    }
    .ModuleBox{
      width: 300px;
      height: 400px;
      border: 1px solid #E1E1E1;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      .el-divider--horizontal{
        margin: 0;
        width: calc(100% - 10px);
      }
      .el-collapse-item__wrap{
        border: 0;
      }
      .el-collapse-item__header{
        border: 0;
      }
      .colorbox{
        width: 16px;
        height: 16px;
        display: inline-block;
      }
      .el-collapse-item {
        padding-left: 10px;
      }
      .el-collapse-item__content {
        padding: 0;
      }
    }
    .ColorPickBox{
      width: 600px;
      height: 400px;
      margin-left: 10px;
      .el-color-picker{
        width: 120px;
      }
      .el-color-picker__trigger{
        width: 120px;
      }
      .radioPick{
        width: 100%;
        height: 48px;
        border: 1px solid #E1E1E1;
        padding-left: 25px;
        line-height: 48px;
        box-sizing: border-box;
      }
      .colorPick::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      .colorPick::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .colorPick::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        border-radius: 5px;
        background: #fff;
      }
      .colorPick{
        width: 100%;
        height: 352px;
        padding-left: 25px;
        border: 1px solid #E1E1E1;
        border-top: 0;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .checkbox{
      padding-left: 16px;
      display: flex;
      flex-wrap: wrap;
      .checkboxItem{
        width: 240px;
        margin-right: 10px;
        margin-bottom: 20px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        .el-checkbox{
          margin-right: 10px;
        }
        .el-checkbox__label{
          width: 216px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          vertical-align: bottom;
        }
      }
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  // 修改按钮样式
  .el-button--default{
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .el-button--default:focus, .el-button--default:hover{
    color: #3BC6B9;
    border-color: #3BC6B9;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #606266;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}

</style>
